
import { Tag, Loader2 } from 'lucide-react';
import { CategoryCard } from './CategoryCard';
import { Product } from './ProductCard';

interface CategoryGridProps {
  categories: string[];
  products: Product[];
  loading: boolean;
}

export function CategoryGrid({ categories, products, loading }: CategoryGridProps) {
  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="ml-2 text-muted-foreground">Loading categories...</p>
      </div>
    );
  }

  if (categories.length === 0) {
    return (
      <div className="text-center py-10 text-muted-foreground">
        <Tag className="mx-auto h-12 w-12 text-muted-foreground/50" />
        <p className="mt-4">No product categories found</p>
        <p className="text-sm">Add categories to your products to organize them</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {categories.map(category => (
        <CategoryCard 
          key={category} 
          category={category} 
          products={products} 
        />
      ))}
    </div>
  );
}
